export const INTERNAL_SERVER_ERROR = 500;
export const SERVER_IS_UNAVAILABLE = 503;
export const INVALID_JWT = 813;
export const INVALID_VERIFICATION_TOKEN = 806;
export const EXPIRED_VERIFICATION_TOKEN = 807;
export const INVALID_REFRESH_TOKEN = 829;
export const INVALID_SESSION_ERROR = 822;
export const EMPTY_JWT = 8922;

export const GLOBAL_ERRORS_CODE_LIST = [
  INTERNAL_SERVER_ERROR,
  SERVER_IS_UNAVAILABLE,
  INVALID_JWT,
  INVALID_VERIFICATION_TOKEN,
  EXPIRED_VERIFICATION_TOKEN,
  INVALID_REFRESH_TOKEN,
  INVALID_SESSION_ERROR,
];
